<template>
    <div id="main-container">
        <h1 id="page-title">{{ pageName }}</h1>

        <div>
            <Accordion v-model:activeIndex="state.activeAccordionIndex" @update:activeIndex="onAccordionChange">
                <AccordionTab header="POD">
                    <div>
                        <TabView class="custom-tabview" @tab-change="onTabChange" v-model:activeIndex="state.tabViewActiveIndex">
                            <TabPanel header="Tutela Richiesta">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">
                                        <div v-if="state.loadingButton" class="mr-2">
                                            <ProgressSpinner style="width: 1.5em; height: 1.5em;" />
                                        </div>

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        />

                                        <Button     
                                            label="Genera CSV" 
                                            icon="pi pi-file-excel"
                                            class="p-button-sm p-button-rounded" 
                                            @click="generaCsvPod()" 
                                        />
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :dataKey="'id'"
                                        :value="state.tutelaRichieste"
                                        :lazy="true"
                                        :paginator="true"
                                        :totalRecords="state.pagination?.total || 0"
                                        :rows="state.rows"
                                        :first="(state.currentPage - 1) * state.rows"
                                        :scrollable="true"
                                        :selection="state.changeTypeStateItems"
                                        :sortField="state.sortField"
                                        :sortOrder="state.sortOrder"
                                        :rowsPerPageOptions="[10, 25, 50, 100, 250, 500]"
                                        @update:selection="onSelectionChange"
                                        @page="onPageChange"
                                        @sort="onSort"
                                        @rows-per-page-change="onRowsPerPageChange"
                                        v-if="!state.loading"
                                    >
                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText 
                                                    v-model="globalSearch" 
                                                    placeholder="Cerca POD"
                                                    @keydown.enter="onSearchEnter"
                                                />
                                            </IconField>

                                            <small class="text-xs text-gray-400 italic">
                                                Inserisci almeno 8 caratteri per cercare un POD. Premi invio per avviare la ricerca.
                                            </small>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column field="code" header="Codice POD" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="agente_firmatario" header="Agente firmatario" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                    </DataTable>

                                </div>
                            </TabPanel>

                            <TabPanel header="Tutela in Lavorazione">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">
                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        />
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem surface-0 border-1 border-300 border-round mr-2"></div>
                                            <span class="text-sm">Entro 7 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-yellow mr-2"></div>
                                            <span class="text-sm">8 – 14 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-orange mr-2"></div>
                                            <span class="text-sm">15 – 30 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-brown mr-2"></div>
                                            <span class="text-sm">31 – 60 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-danger mr-2"></div>
                                            <span class="text-sm">Oltre 60 giorni</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :dataKey="'id'"
                                        :value="state.tutelaLavorazione"
                                        :lazy="true"
                                        :paginator="true"
                                        :totalRecords="state.pagination?.total || 0"
                                        :rows="state.rows"
                                        :first="(state.currentPage - 1) * state.rows"
                                        :scrollable="true"
                                        :selection="state.changeTypeStateItems"
                                        :sortField="state.sortField"
                                        :sortOrder="state.sortOrder"
                                        :rowsPerPageOptions="[10, 25, 50, 100, 250, 500]"
                                        @update:selection="onSelectionChange"
                                        @page="onPageChange"
                                        @sort="onSort"
                                        @rows-per-page-change="onRowsPerPageChange"
                                        v-if="!state.loading"
                                        :rowClass="dataPraticaColor"
                                    >
                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText 
                                                    v-model="globalSearch" 
                                                    placeholder="Cerca POD"
                                                    @keydown.enter="onSearchEnter"
                                                />
                                            </IconField>

                                            <small class="text-xs text-gray-400 italic">
                                                Inserisci almeno 8 caratteri per cercare un POD. Premi invio per avviare la ricerca.
                                            </small>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column field="code" header="Codice POD" style="width: 200px;" sortable />
                                        <Column field="data_pratica" header="Data pratica" style="width: 200px;" sortable />
                                        <Column field="data_decorrenza" header="Data decorrenza" style="width: 200px;" sortable />
                                        <Column field="tipologia_risoluzione" header="Tipologia Risoluzione" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="agente_firmatario" header="Agente firmatario" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                    </DataTable>

                                </div>
                            </TabPanel>

                            <TabPanel header="Tutela evasa">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-between p-3 flex-wrap gap-3">
                                        <div class="flex align-items-center gap-3 flex-wrap">
                                            <div class="flex align-items-center gap-2">
                                                <span class="decorrenza-legend decorrenza-legend--auto"></span>
                                                <span class="text-sm">Data automatica</span>
                                            </div>
                                            <div class="flex align-items-center gap-2">
                                                <span class="decorrenza-legend decorrenza-legend--manual"></span>
                                                <span class="text-sm">Data modificata manualmente</span>
                                            </div>
                                            <div class="flex align-items-center gap-2">
                                                <i class="pi pi-pencil text-xs text-gray-500"></i>
                                                <span class="text-sm">Clicca sulla data per modificarla</span>
                                            </div>
                                        </div>

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        />
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :dataKey="'id'"
                                        :value="state.tutelaEvasa"
                                        :lazy="true"
                                        :paginator="true"
                                        :totalRecords="state.pagination?.total || 0"
                                        :rows="state.rows"
                                        :first="(state.currentPage - 1) * state.rows"
                                        :scrollable="true"
                                        :selection="state.changeTypeStateItems"
                                        :sortField="state.sortField"
                                        :sortOrder="state.sortOrder"
                                        :rowsPerPageOptions="[10, 25, 50, 100, 250, 500]"
                                        @update:selection="onSelectionChange"
                                        @page="onPageChange"
                                        @sort="onSort"
                                        @rows-per-page-change="onRowsPerPageChange"
                                        v-if="!state.loading"
                                    >
                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText 
                                                    v-model="globalSearch" 
                                                    placeholder="Cerca POD"
                                                    @keydown.enter="onSearchEnter"
                                                />
                                            </IconField>

                                            <small class="text-xs text-gray-400 italic">
                                                Inserisci almeno 8 caratteri per cercare un POD. Premi invio per avviare la ricerca.
                                            </small>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column field="code" header="Codice POD" style="width: 200px;" sortable />

                                        <Column field="data_pratica" header="Data pratica" style="width: 180px;" sortable>
                                            <template #body="slotProps">
                                                {{ formatDateDisplay(slotProps.data.data_pratica) }}
                                            </template>
                                        </Column>

                                        <Column field="data_decorrenza" header="Data decorrenza" style="width: 340px;" sortable>
                                            <template #body="slotProps">
                                                <div
                                                    v-if="!isEditingDecorrenza('pod', slotProps.data)"
                                                    class="flex flex-column gap-2 decorrenza-cell"
                                                    @click="startEditDecorrenza('pod', slotProps.data)"
                                                >
                                                    <div class="flex align-items-center gap-2 flex-wrap">
                                                        <span
                                                            class="decorrenza-badge decorrenza-badge--clickable"
                                                            :class="Number(slotProps.data.data_decorrenza_modificata) === 1 ? 'decorrenza-badge--manual' : 'decorrenza-badge--auto'"
                                                        >
                                                            {{ formatDateDisplay(slotProps.data.data_decorrenza) }}
                                                        </span>

                                                        <small
                                                            v-if="Number(slotProps.data.data_decorrenza_modificata) === 1"
                                                            class="decorrenza-label decorrenza-label--manual"
                                                        >
                                                            Modificata manualmente
                                                        </small>

                                                        <small
                                                            v-else
                                                            class="decorrenza-label decorrenza-label--auto"
                                                        >
                                                            Automatica
                                                        </small>
                                                    </div>

                                                    <small class="text-xs text-gray-500">
                                                        Clicca per modificare
                                                    </small>
                                                </div>

                                                <div v-else class="flex flex-column gap-2">
                                                    <Calendar
                                                        v-model="state.editingDecorrenzaValue"
                                                        dateFormat="dd/mm/yy"
                                                        :manualInput="false"
                                                        showIcon
                                                        class="w-full"
                                                    />

                                                    <div class="flex gap-2 flex-wrap">
                                                        <Button
                                                            label="Salva"
                                                            icon="pi pi-check"
                                                            class="p-button-sm p-button-success"
                                                            :loading="state.savingDecorrenza"
                                                            @click="saveDecorrenza('pod', slotProps.data)"
                                                        />

                                                        <Button
                                                            label="Annulla"
                                                            icon="pi pi-times"
                                                            class="p-button-sm p-button-secondary"
                                                            :disabled="state.savingDecorrenza"
                                                            @click="cancelEditDecorrenza"
                                                        />

                                                        <Button
                                                            label="Ripristina"
                                                            icon="pi pi-refresh"
                                                            class="p-button-sm p-button-warning"
                                                            :disabled="Number(slotProps.data.data_decorrenza_modificata) !== 1 || state.savingDecorrenza"
                                                            @click="resetDecorrenza('pod', slotProps.data)"
                                                        />
                                                    </div>
                                                </div>
                                            </template>
                                        </Column>

                                        <Column field="tipologia_risoluzione" header="Tipologia Risoluzione" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="agente_firmatario" header="Agente firmatario" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                    </DataTable>

                                </div>
                            </TabPanel>

                            <TabPanel header="Tutela KO">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">
                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        />
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :dataKey="'id'"
                                        :value="state.tutelaKO"
                                        :lazy="true"
                                        :paginator="true"
                                        :totalRecords="state.pagination?.total || 0"
                                        :rows="state.rows"
                                        :first="(state.currentPage - 1) * state.rows"
                                        :scrollable="true"
                                        :selection="state.changeTypeStateItems"
                                        :sortField="state.sortField"
                                        :sortOrder="state.sortOrder"
                                        :rowsPerPageOptions="[10, 25, 50, 100, 250, 500]"
                                        @update:selection="onSelectionChange"
                                        @page="onPageChange"
                                        @sort="onSort"
                                        @rows-per-page-change="onRowsPerPageChange"
                                        v-if="!state.loading"
                                    >
                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText 
                                                    v-model="globalSearch" 
                                                    placeholder="Cerca POD"
                                                    @keydown.enter="onSearchEnter"
                                                />
                                            </IconField>

                                            <small class="text-xs text-gray-400 italic">
                                                Inserisci almeno 8 caratteri per cercare un POD. Premi invio per avviare la ricerca.
                                            </small>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column field="code" header="Codice POD" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="agente_firmatario" header="Agente firmatario" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                    </DataTable>

                                </div>
                            </TabPanel>
                        </TabView>
                    </div>
                </AccordionTab>

                <AccordionTab header="PDR">
                    <div>
                        <TabView class="custom-tabview" @tab-change="onTabChangePdr" v-model:activeIndex="state.tabViewActiveIndexPdr">
                            <TabPanel header="Tutela Richiesta">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">
                                        <div v-if="state.loadingButton" class="mr-2">
                                            <ProgressSpinner style="width: 1.5em; height: 1.5em;" />
                                        </div>

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        />

                                        <Button     
                                            label="Genera CSV" 
                                            icon="pi pi-file-excel"
                                            class="p-button-sm p-button-rounded" 
                                            @click="generaCsvPdr()" 
                                        />
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :dataKey="'id'"
                                        :value="state.tutelaRichiestePdr"
                                        :lazy="true"
                                        :paginator="true"
                                        :totalRecords="state.pagination?.total || 0"
                                        :rows="state.rows"
                                        :first="(state.currentPage - 1) * state.rows"
                                        :scrollable="true"
                                        :selection="state.changeTypeStateItems"
                                        :sortField="state.sortField"
                                        :sortOrder="state.sortOrder"
                                        :rowsPerPageOptions="[10, 25, 50, 100, 250, 500]"
                                        @update:selection="onSelectionChange"
                                        @page="onPageChangePdr"
                                        @sort="onSort"
                                        @rows-per-page-change="onRowsPerPageChange"
                                        v-if="!state.loading"
                                    >
                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText 
                                                    v-model="globalSearchPdr" 
                                                    placeholder="Cerca PDR"
                                                    @keydown.enter="onSearchEnterPdr"
                                                />
                                            </IconField>

                                            <small class="text-xs text-gray-400 italic">
                                                Inserisci almeno 8 caratteri per cercare un PDR. Premi invio per avviare la ricerca.
                                            </small>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column field="code" header="Codice PDR" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="agente_firmatario" header="Agente firmatario" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                    </DataTable>

                                </div>
                            </TabPanel>

                            <TabPanel header="Tutela in Lavorazione">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">
                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        />
                                    </div>

                                    <div class="flex flex-column md:flex-row gap-3 mb-3">
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem surface-0 border-1 border-300 border-round mr-2"></div>
                                            <span class="text-sm">Entro 7 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-yellow mr-2"></div>
                                            <span class="text-sm">8 – 14 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-orange mr-2"></div>
                                            <span class="text-sm">15 – 30 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-light-brown mr-2"></div>
                                            <span class="text-sm">31 – 60 giorni</span>
                                        </div>
                                        <div class="flex align-items-center gap-2 mr-2">
                                            <div class="w-2rem h-2rem border-round row-danger mr-2"></div>
                                            <span class="text-sm">Oltre 60 giorni</span>
                                        </div>
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :dataKey="'id'"
                                        :value="state.tutelaLavorazionePdr"
                                        :lazy="true"
                                        :paginator="true"
                                        :totalRecords="state.pagination?.total || 0"
                                        :rows="state.rows"
                                        :first="(state.currentPage - 1) * state.rows"
                                        :scrollable="true"
                                        :selection="state.changeTypeStateItems"
                                        :sortField="state.sortField"
                                        :sortOrder="state.sortOrder"
                                        :rowsPerPageOptions="[10, 25, 50, 100, 250, 500]"
                                        @update:selection="onSelectionChange"
                                        @page="onPageChangePdr"
                                        @sort="onSort"
                                        @rows-per-page-change="onRowsPerPageChange"
                                        v-if="!state.loading"
                                        :rowClass="dataPraticaColor"
                                    >
                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText 
                                                    v-model="globalSearchPdr" 
                                                    placeholder="Cerca PDR"
                                                    @keydown.enter="onSearchEnterPdr"
                                                />
                                            </IconField>

                                            <small class="text-xs text-gray-400 italic">
                                                Inserisci almeno 8 caratteri per cercare un PDR. Premi invio per avviare la ricerca.
                                            </small>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column field="code" header="Codice PDR" style="width: 200px;" sortable />
                                        <Column field="data_pratica" header="Data pratica" style="width: 200px;" sortable />
                                        <Column field="data_decorrenza" header="Data decorrenza" style="width: 200px;" sortable />
                                        <Column field="tipologia_risoluzione" header="Tipologia Risoluzione" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="agente_firmatario" header="Agente firmatario" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                    </DataTable>

                                </div>
                            </TabPanel>

                            <TabPanel header="Tutela evasa">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-between p-3 flex-wrap gap-3">
                                        <div class="flex align-items-center gap-3 flex-wrap">
                                            <div class="flex align-items-center gap-2">
                                                <span class="decorrenza-legend decorrenza-legend--auto"></span>
                                                <span class="text-sm">Data automatica</span>
                                            </div>
                                            <div class="flex align-items-center gap-2">
                                                <span class="decorrenza-legend decorrenza-legend--manual"></span>
                                                <span class="text-sm">Data modificata manualmente</span>
                                            </div>
                                            <div class="flex align-items-center gap-2">
                                                <i class="pi pi-pencil text-xs text-gray-500"></i>
                                                <span class="text-sm">Clicca sulla data per modificarla</span>
                                            </div>
                                        </div>

                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        />
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :dataKey="'id'"
                                        :value="state.tutelaEvasaPdr"
                                        :lazy="true"
                                        :paginator="true"
                                        :totalRecords="state.pagination?.total || 0"
                                        :rows="state.rows"
                                        :first="(state.currentPage - 1) * state.rows"
                                        :scrollable="true"
                                        :selection="state.changeTypeStateItems"
                                        :sortField="state.sortField"
                                        :sortOrder="state.sortOrder"
                                        :rowsPerPageOptions="[10, 25, 50, 100, 250, 500]"
                                        @update:selection="onSelectionChange"
                                        @page="onPageChangePdr"
                                        @sort="onSort"
                                        @rows-per-page-change="onRowsPerPageChange"
                                        v-if="!state.loading"
                                    >
                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText 
                                                    v-model="globalSearchPdr" 
                                                    placeholder="Cerca PDR"
                                                    @keydown.enter="onSearchEnterPdr"
                                                />
                                            </IconField>

                                            <small class="text-xs text-gray-400 italic">
                                                Inserisci almeno 8 caratteri per cercare un PDR. Premi invio per avviare la ricerca.
                                            </small>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column field="code" header="Codice PDR" style="width: 200px;" sortable />

                                        <Column field="data_pratica" header="Data pratica" style="width: 180px;" sortable>
                                            <template #body="slotProps">
                                                {{ formatDateDisplay(slotProps.data.data_pratica) }}
                                            </template>
                                        </Column>

                                        <Column field="data_decorrenza" header="Data decorrenza" style="width: 340px;" sortable>
                                            <template #body="slotProps">
                                                <div
                                                    v-if="!isEditingDecorrenza('pdr', slotProps.data)"
                                                    class="flex flex-column gap-2 decorrenza-cell"
                                                    @click="startEditDecorrenza('pdr', slotProps.data)"
                                                >
                                                    <div class="flex align-items-center gap-2 flex-wrap">
                                                        <span
                                                            class="decorrenza-badge decorrenza-badge--clickable"
                                                            :class="Number(slotProps.data.data_decorrenza_modificata) === 1 ? 'decorrenza-badge--manual' : 'decorrenza-badge--auto'"
                                                        >
                                                            {{ formatDateDisplay(slotProps.data.data_decorrenza) }}
                                                        </span>

                                                        <small
                                                            v-if="Number(slotProps.data.data_decorrenza_modificata) === 1"
                                                            class="decorrenza-label decorrenza-label--manual"
                                                        >
                                                            Modificata manualmente
                                                        </small>

                                                        <small
                                                            v-else
                                                            class="decorrenza-label decorrenza-label--auto"
                                                        >
                                                            Automatica
                                                        </small>
                                                    </div>

                                                    <small class="text-xs text-gray-500">
                                                        Clicca per modificare
                                                    </small>
                                                </div>

                                                <div v-else class="flex flex-column gap-2">
                                                    <Calendar
                                                        v-model="state.editingDecorrenzaValue"
                                                        dateFormat="dd/mm/yy"
                                                        :manualInput="false"
                                                        showIcon
                                                        class="w-full"
                                                    />

                                                    <div class="flex gap-2 flex-wrap">
                                                        <Button
                                                            label="Salva"
                                                            icon="pi pi-check"
                                                            class="p-button-sm p-button-success"
                                                            :loading="state.savingDecorrenza"
                                                            @click="saveDecorrenza('pdr', slotProps.data)"
                                                        />

                                                        <Button
                                                            label="Annulla"
                                                            icon="pi pi-times"
                                                            class="p-button-sm p-button-secondary"
                                                            :disabled="state.savingDecorrenza"
                                                            @click="cancelEditDecorrenza"
                                                        />

                                                        <Button
                                                            label="Ripristina"
                                                            icon="pi pi-refresh"
                                                            class="p-button-sm p-button-warning"
                                                            :disabled="Number(slotProps.data.data_decorrenza_modificata) !== 1 || state.savingDecorrenza"
                                                            @click="resetDecorrenza('pdr', slotProps.data)"
                                                        />
                                                    </div>
                                                </div>
                                            </template>
                                        </Column>

                                        <Column field="tipologia_risoluzione" header="Tipologia Risoluzione" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="agente_firmatario" header="Agente firmatario" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                    </DataTable>

                                </div>
                            </TabPanel>

                            <TabPanel header="Tutela KO">
                                <div id="data_table-div">

                                    <div class="flex align-items-center justify-content-end p-3">
                                        <Button     
                                            label="Cambia Stato" 
                                            icon="pi pi-pencil"
                                            class="p-button-sm p-button-rounded mr-2" 
                                            @click="cambiaStato()" 
                                        />
                                    </div>

                                    <div class="flex justify-content-center align-items-center" style="height: 200px;" v-if="state.loading">
                                        <ProgressSpinner />
                                    </div>

                                    <DataTable 
                                        :dataKey="'id'"
                                        :value="state.tutelaKOPdr"
                                        :lazy="true"
                                        :paginator="true"
                                        :totalRecords="state.pagination?.total || 0"
                                        :rows="state.rows"
                                        :first="(state.currentPage - 1) * state.rows"
                                        :scrollable="true"
                                        :selection="state.changeTypeStateItems"
                                        :sortField="state.sortField"
                                        :sortOrder="state.sortOrder"
                                        :rowsPerPageOptions="[10, 25, 50, 100, 250, 500]"
                                        @update:selection="onSelectionChange"
                                        @page="onPageChangePdr"
                                        @sort="onSort"
                                        @rows-per-page-change="onRowsPerPageChange"
                                        v-if="!state.loading"
                                    >
                                        <template #header>
                                            <IconField iconPosition="left">
                                                <InputIcon>
                                                    <i class="pi pi-search" />
                                                </InputIcon>
                                                <InputText 
                                                    v-model="globalSearchPdr" 
                                                    placeholder="Cerca PDR"
                                                    @keydown.enter="onSearchEnterPdr"
                                                />
                                            </IconField>

                                            <small class="text-xs text-gray-400 italic">
                                                Inserisci almeno 8 caratteri per cercare un PDR. Premi invio per avviare la ricerca.
                                            </small>
                                        </template>

                                        <Column selectionMode="multiple" :headerStyle="{ width: '3em' }" />
                                        <Column field="code" header="Codice PDR" style="width: 200px;" sortable />
                                        <Column field="piva" header="Partita Iva" style="width: 200px;" sortable />
                                        <Column field="codfis" header="Codice Fiscale" style="width: 200px;" sortable />
                                        <Column field="cellulare" header="Numero Cellulare" style="width: 200px;" sortable />
                                        <Column field="distributore" header="Distributore" style="width: 200px;" sortable />
                                        <Column field="distributore_piva" header="Parita Iva Distributore" style="width: 200px;" sortable />
                                        <Column field="cliente" header="Cliente" style="width: 200px;" sortable />
                                        <Column field="rappresentante" header="Rappresentante" style="width: 200px;" sortable />
                                        <Column field="agente" header="Agente" style="width: 200px;" sortable />
                                        <Column field="agente_firmatario" header="Agente firmatario" style="width: 200px;" sortable />
                                        <Column field="cc" header="CC" style="width: 200px;" sortable />
                                        <Column field="udd" header="UDD" style="width: 200px;" sortable />
                                        <Column field="codice_dispacciamento" header="Codice Dispacciamento" style="width: 200px;" sortable />
                                        <Column field="totale_fattura" header="Totale Fattura" style="width: 200px;" sortable />
                                        <Column field="pagato" header="Pagato" style="width: 200px;" sortable />
                                        <Column field="saldo" header="Saldo" style="width: 200px;" sortable />
                                        <Column field="saldo_ultimo_mese" header="Saldo Ultimo mese" style="width: 200px;" sortable />
                                    </DataTable>

                                </div>
                            </TabPanel>
                        </TabView>
                    </div>
                </AccordionTab>
            </Accordion>
        </div>
    </div>

    <div id="cambia_stato_div">
        <Dialog 
            :visible="state.showCambiaStatoDialog" 
            :closable="false"
            modal 
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ width: '70vw' }" 
        >
            <template #header>
                <div class="w-full text-center">
                    <h3>Cambia Stato</h3>
                </div>
            </template>

            <div class="flex justify-content-around align-items-center p-4">
                <div class="flex-child-left w-6 p-2">
                    <div class="w-full text-center p-2">
                        <h4>POD / PDR</h4>
                    </div>

                    <div v-if="state.changeTypeStateItems.length == 0">
                        <div class="flex justify-content-center align-items-center p-2">
                            <span>Nessun POD / PDR selezionato</span>
                        </div>
                    </div>

                    <div>
                        <VirtualScroller 
                            :items="state.changeTypeStateItems" 
                            :item-size="50" 
                            :style="{ height: '350px', width: '100%' }"
                        >
                            <template #item="slotProps">
                                <div class="flex justify-content-between align-items-center p-2 border-bottom">
                                    <span>{{ slotProps.item.code }}</span>
                                    <Button 
                                        :label="'X'" 
                                        :id="'button-' + slotProps.item.code" 
                                        @click="eliminaPodPdrDaElenco(slotProps.item.code)"
                                        class="p-button-danger"
                                        :title="'Elimina l\'elemento ' + slotProps.item.code + ' dalla lista'"
                                    />
                                </div>
                            </template>
                        </VirtualScroller>
                    </div>
                </div>

                <div class="flex-child-right h-350px w-6 p-2">
                    <div class="w-full text-center p-2">
                        <label for="type_state_dropdown">Scegli lo stato fornitura:</label>
                        <Dropdown 
                            name="type_state_dropdown"
                            :options="state.type_state_options"
                            v-model="state.prossimoStato"
                            optionLabel="stato_nome"
                            placeholder="Scegli stato"
                            class="w-full mt-2"
                        />
                    </div>
                </div>
            </div>

            <template #footer>
                <Button
                    label="Conferma"
                    icon="pi pi-check"
                    @click="cambiaStatoConferma()"
                    class="p-button-success"
                />

                <Button
                    label="Chiudi"
                    icon="pi pi-times"
                    @click="state.showCambiaStatoDialog = false"
                    class="p-button-danger"
                    title="Chiudi la finestra"
                />
            </template>
        </Dialog>
    </div>
</template>

<script>
import { reactive, ref, onMounted, getCurrentInstance } from "vue";
import { TabView, TabPanel } from "primevue/tabview";
import { DataTable } from "primevue/datatable";
import Calendar from "primevue/calendar";
import OperationService from "@/services/ask-operation/operation-service.js";
import ProgressSpinner from "primevue/progressspinner";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import Dialog from "primevue/dialog";
import VirtualScroller from "primevue/virtualscroller";

export default {
    components: {
        TabView,
        TabPanel,
        DataTable,
        Calendar,
        ProgressSpinner,
        Accordion,
        AccordionTab,
        Dialog,
        VirtualScroller
    },
    setup() {
        const state = reactive({
            loadingButton: false,
            showCambiaStatoDialog: false,
            activeAccordionIndex: null,

            tabViewActiveIndex: 0,
            tabViewActiveIndexPdr: 0,

            tutelaRichieste: [],
            tutelaLavorazione: [],
            tutelaEvasa: [],
            tutelaKO: [],

            tutelaRichiestePdr: [],
            tutelaLavorazionePdr: [],
            tutelaEvasaPdr: [],
            tutelaKOPdr: [],

            rows: 10,
            sortField: "id",
            sortOrder: 1,
            loading: false,
            changeTypeStateItems: [],
            type_state_options: [],
            prossimoStato: null,
            pagination: null,
            currentPage: 1,

            editingDecorrenzaType: null,
            editingDecorrenzaId: null,
            editingDecorrenzaValue: null,
            savingDecorrenza: false
        });

        const globalSearch = ref("");
        const globalSearchPdr = ref("");

        const { appContext } = getCurrentInstance();
        const $http = appContext.config.globalProperties.$http;
        const $eventBus = appContext.config.globalProperties.$eventBus;
        const $toast = appContext.config.globalProperties.$toast;

        const service = new OperationService($http, $eventBus);

        const showWarn = (message) => {
            if ($toast) {
                $toast.add({
                    severity: "warn",
                    summary: "Attenzione",
                    detail: message,
                    life: 3000
                });
            } else {
                alert(message);
            }
        };

        const formatDateDisplay = (value) => {
            if (!value) {
                return '-';
            }

            if (typeof value !== 'string') {
                return '-';
            }

            if (value.includes('/')) {
                return value;
            }

            if (value.includes('-')) {
                const parts = value.split('-');

                if (parts.length < 3) {
                    return value;
                }

                const year = parts[0];
                const month = parts[1];
                const day = parts[2].substring(0, 2);

                return `${day}/${month}/${year}`;
            }

            return value;
        };

        const toDate = (value) => {
            if (!value) {
                return null;
            }

            if (value instanceof Date) {
                return value;
            }

            if (typeof value !== 'string') {
                return null;
            }

            if (value.includes('/')) {
                const parts = value.split('/');
                if (parts.length !== 3) {
                    return null;
                }

                const day = Number(parts[0]);
                const month = Number(parts[1]) - 1;
                const year = Number(parts[2]);

                return new Date(year, month, day);
            }

            if (value.includes('-')) {
                const parts = value.split('-');
                if (parts.length < 3) {
                    return null;
                }

                const year = Number(parts[0]);
                const month = Number(parts[1]) - 1;
                const day = Number(parts[2].substring(0, 2));

                return new Date(year, month, day);
            }

            return null;
        };

        const formatDateForApi = (value) => {
            if (!value) {
                return null;
            }

            const date = new Date(value);

            if (Number.isNaN(date.getTime())) {
                return null;
            }

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");

            return `${year}-${month}-${day} 00:00:00`;
        };

        const caricaStatiFornitura = async () => {
            try {
                const response = await service.geTipiStatoFornituraTutela();
                state.type_state_options = response;
            } catch (error) {
                console.error("Errore durante il caricamento degli stati della fornitura:", error);
            }
        };

        const elaborateResponse = (response) => {
            response.forEach((ele) => {
                const totaleFattura = parseFloat(ele.totale_fattura) || 0;
                const pagato = parseFloat(ele.pagato) || 0;
                const saldoUltimoMese = parseFloat(ele.saldo_ultimo_mese) || 0;

                let saldo = totaleFattura - pagato;
                ele.saldo = saldo > 0.001 ? saldo : 0;

                ele.totale_fattura = Number(totaleFattura.toFixed(2));
                ele.saldo_ultimo_mese = Number(saldoUltimoMese.toFixed(2));
                ele.pagato = Number(pagato.toFixed(2));
                ele.saldo = Number(ele.saldo.toFixed(2));
            });

            return response;
        };

        const isEditingDecorrenza = (type, row) => {
            return state.editingDecorrenzaType === type && state.editingDecorrenzaId === row.id;
        };

        const startEditDecorrenza = (type, row) => {
            state.editingDecorrenzaType = type;
            state.editingDecorrenzaId = row.id;
            state.editingDecorrenzaValue = row.data_decorrenza ? toDate(row.data_decorrenza) : null;
        };

        const cancelEditDecorrenza = () => {
            state.editingDecorrenzaType = null;
            state.editingDecorrenzaId = null;
            state.editingDecorrenzaValue = null;
        };

        const caricaRichiesteTutelaPod = async (page = 1, perPage = state.rows) => {
            state.loading = true;
            try {
                const response = await service.getStatoTutelaFornitura("pod", 2, page, perPage, state.sortField, state.sortOrder);
                state.tutelaRichieste = elaborateResponse(response.data);
                state.pagination = response.pagination;
                state.currentPage = response.pagination.current_page;
            } catch (error) {
                console.error("Errore durante il caricamento delle richieste:", error);
            } finally {
                state.loading = false;
            }
        };

        const caricaTutelaLavorazionePod = async (page = 1, perPage = state.rows) => {
            state.loading = true;
            try {
                const response = await service.getStatoTutelaFornitura("pod", 3, page, perPage, state.sortField, state.sortOrder);
                state.tutelaLavorazione = elaborateResponse(response.data);
                state.pagination = response.pagination;
                state.currentPage = response.pagination.current_page;
            } catch (error) {
                console.error("Errore durante il caricamento delle richieste:", error);
            } finally {
                state.loading = false;
            }
        };

        const caricaTutelaEvasaPod = async (page = 1, perPage = state.rows) => {
            state.loading = true;
            try {
                const response = await service.getStatoTutelaFornitura("pod", 4, page, perPage, state.sortField, state.sortOrder);
                state.tutelaEvasa = elaborateResponse(response.data);
                state.pagination = response.pagination;
                state.currentPage = response.pagination.current_page;
            } catch (error) {
                console.error("Errore durante il caricamento delle richieste:", error);
            } finally {
                state.loading = false;
            }
        };

        const caricaTutelaKOPod = async (page = 1, perPage = state.rows) => {
            state.loading = true;
            try {
                const response = await service.getStatoTutelaFornitura("pod", 5, page, perPage, state.sortField, state.sortOrder);
                state.tutelaKO = elaborateResponse(response.data);
                state.pagination = response.pagination;
                state.currentPage = response.pagination.current_page;
            } catch (error) {
                console.error("Errore durante il caricamento delle richieste:", error);
            } finally {
                state.loading = false;
            }
        };

        const caricaRichiesteTutelaPdr = async (page = 1, perPage = state.rows) => {
            state.loading = true;
            try {
                const response = await service.getStatoTutelaFornitura("pdr", 2, page, perPage, state.sortField, state.sortOrder);
                state.tutelaRichiestePdr = elaborateResponse(response.data);
                state.pagination = response.pagination;
                state.currentPage = response.pagination.current_page;
            } catch (error) {
                console.error("Errore durante il caricamento delle richieste:", error);
            } finally {
                state.loading = false;
            }
        };

        const caricaTutelaLavorazionePdr = async (page = 1, perPage = state.rows) => {
            state.loading = true;
            try {
                const response = await service.getStatoTutelaFornitura("pdr", 3, page, perPage, state.sortField, state.sortOrder);
                state.tutelaLavorazionePdr = elaborateResponse(response.data);
                state.pagination = response.pagination;
                state.currentPage = response.pagination.current_page;
            } catch (error) {
                console.error("Errore durante il caricamento delle richieste:", error);
            } finally {
                state.loading = false;
            }
        };

        const caricaTutelaEvasaPdr = async (page = 1, perPage = state.rows) => {
            state.loading = true;
            try {
                const response = await service.getStatoTutelaFornitura("pdr", 4, page, perPage, state.sortField, state.sortOrder);
                state.tutelaEvasaPdr = elaborateResponse(response.data);
                state.pagination = response.pagination;
                state.currentPage = response.pagination.current_page;
            } catch (error) {
                console.error("Errore durante il caricamento delle richieste:", error);
            } finally {
                state.loading = false;
            }
        };

        const caricaTutelaKOPdr = async (page = 1, perPage = state.rows) => {
            state.loading = true;
            try {
                const response = await service.getStatoTutelaFornitura("pdr", 5, page, perPage, state.sortField, state.sortOrder);
                state.tutelaKOPdr = elaborateResponse(response.data);
                state.pagination = response.pagination;
                state.currentPage = response.pagination.current_page;
            } catch (error) {
                console.error("Errore durante il caricamento delle richieste:", error);
            } finally {
                state.loading = false;
            }
        };

        const refreshCurrentTab = async () => {
            if (state.activeAccordionIndex === 0) {
                switch (state.tabViewActiveIndex) {
                    case 0:
                        await caricaRichiesteTutelaPod(state.currentPage, state.rows);
                        break;
                    case 1:
                        await caricaTutelaLavorazionePod(state.currentPage, state.rows);
                        break;
                    case 2:
                        await caricaTutelaEvasaPod(state.currentPage, state.rows);
                        break;
                    case 3:
                        await caricaTutelaKOPod(state.currentPage, state.rows);
                        break;
                }
            } else if (state.activeAccordionIndex === 1) {
                switch (state.tabViewActiveIndexPdr) {
                    case 0:
                        await caricaRichiesteTutelaPdr(state.currentPage, state.rows);
                        break;
                    case 1:
                        await caricaTutelaLavorazionePdr(state.currentPage, state.rows);
                        break;
                    case 2:
                        await caricaTutelaEvasaPdr(state.currentPage, state.rows);
                        break;
                    case 3:
                        await caricaTutelaKOPdr(state.currentPage, state.rows);
                        break;
                }
            }
        };

        const saveDecorrenza = async (type, row) => {
            if (!state.editingDecorrenzaValue) {
                showWarn("Seleziona una data decorrenza prima di salvare.");
                return;
            }

            state.savingDecorrenza = true;

            try {
                const dataDecorrenza = formatDateForApi(state.editingDecorrenzaValue);
                const res = await service.updateDataDecorrenzaTutela(row.id, type, dataDecorrenza);

                if (res?.success) {
                    cancelEditDecorrenza();
                    await refreshCurrentTab();
                }
            } catch (error) {
                console.error("Errore durante il salvataggio della data decorrenza:", error);
            } finally {
                state.savingDecorrenza = false;
            }
        };

        const resetDecorrenza = async (type, row) => {
            state.savingDecorrenza = true;

            try {
                cancelEditDecorrenza();
                const res = await service.resetDataDecorrenzaTutela(row.id, type);

                if (res?.success) {
                    await refreshCurrentTab();
                }
            } catch (error) {
                console.error("Errore durante il reset della data decorrenza:", error);
            } finally {
                state.savingDecorrenza = false;
            }
        };

        const onSearchEnter = async () => {
            const search = globalSearch.value?.trim();
            if (!search || search.length < 8) {
                state.tabViewActiveIndex = 0;
                caricaRichiesteTutelaPod();
                return;
            }

            state.loading = true;
            try {
                const response = await service.searchStatoTutelaFornitura("pod", state.tabViewActiveIndex + 2, search);
                if (response) {
                    state.pagination = null;

                    const nuovoStato = response.stato - 2;
                    state.tabViewActiveIndex = nuovoStato;
                    const ris = response.dati.original.data;

                    switch (state.tabViewActiveIndex) {
                        case 0:
                            state.tutelaRichieste = elaborateResponse(ris);
                            break;
                        case 1:
                            state.tutelaLavorazione = elaborateResponse(ris);
                            break;
                        case 2:
                            state.tutelaEvasa = elaborateResponse(ris);
                            break;
                        case 3:
                            state.tutelaKO = elaborateResponse(ris);
                            break;
                    }
                } else {
                    switch (state.tabViewActiveIndex) {
                        case 0:
                            state.tutelaRichieste = [];
                            break;
                        case 1:
                            state.tutelaLavorazione = [];
                            break;
                        case 2:
                            state.tutelaEvasa = [];
                            break;
                        case 3:
                            state.tutelaKO = [];
                            break;
                    }
                }
            } catch (error) {
                console.error("Errore durante la ricerca:", error);
            } finally {
                state.loading = false;
            }
        };

        const onSearchEnterPdr = async () => {
            const search = globalSearchPdr.value?.trim();
            if (!search || search.length < 8) {
                state.tabViewActiveIndexPdr = 0;
                caricaRichiesteTutelaPdr();
                return;
            }

            state.loading = true;
            try {
                const response = await service.searchStatoTutelaFornitura("pdr", state.tabViewActiveIndexPdr + 2, search);
                if (response) {
                    state.pagination = null;

                    const nuovoStato = response.stato - 2;
                    state.tabViewActiveIndexPdr = nuovoStato;
                    const ris = response.dati.original.data;

                    switch (state.tabViewActiveIndexPdr) {
                        case 0:
                            state.tutelaRichiestePdr = elaborateResponse(ris);
                            break;
                        case 1:
                            state.tutelaLavorazionePdr = elaborateResponse(ris);
                            break;
                        case 2:
                            state.tutelaEvasaPdr = elaborateResponse(ris);
                            break;
                        case 3:
                            state.tutelaKOPdr = elaborateResponse(ris);
                            break;
                    }
                } else {
                    switch (state.tabViewActiveIndexPdr) {
                        case 0:
                            state.tutelaRichiestePdr = [];
                            break;
                        case 1:
                            state.tutelaLavorazionePdr = [];
                            break;
                        case 2:
                            state.tutelaEvasaPdr = [];
                            break;
                        case 3:
                            state.tutelaKOPdr = [];
                            break;
                    }
                }
            } catch (error) {
                console.error("Errore durante la ricerca:", error);
            } finally {
                state.loading = false;
            }
        };

        const cambiaStato = () => {
            state.showCambiaStatoDialog = true;
        };

        const onSelectionChange = (selection) => {
            state.changeTypeStateItems = selection;
        };

        const generaCsvPod = async () => {
            const podIds = state.changeTypeStateItems
                .filter((ele) => ele.code?.toUpperCase().startsWith("IT"))
                .map((ele) => ele.id);

            if (podIds.length === 0) {
                try {
                    await service.generazioneCsvTutelaTutti("pod");
                    aggiornaTab();
                    state.changeTypeStateItems = [];
                } catch (err) {
                    console.error("Errore durante la generazione del CSV:", err);
                }
            } else {
                try {
                    await service.generazioneCsvTutela("pod", podIds);
                    aggiornaTab();
                    state.changeTypeStateItems = [];
                } catch (err) {
                    console.error("Errore durante la generazione del CSV:", err);
                }
            }
        };

        const generaCsvPdr = async () => {
            const pdrIds = state.changeTypeStateItems
                .filter((ele) => !!ele.code && !ele.code.toUpperCase().startsWith("IT"))
                .map((ele) => ele.id);

            if (pdrIds.length === 0) {
                try {
                    await service.generazioneCsvTutelaTutti("pdr");
                    aggiornaTab();
                    state.changeTypeStateItems = [];
                } catch (err) {
                    console.error("Errore durante la generazione del CSV:", err);
                }
            } else {
                try {
                    await service.generazioneCsvTutela("pdr", pdrIds);
                    aggiornaTab();
                    state.changeTypeStateItems = [];
                } catch (err) {
                    console.error("Errore durante la generazione del CSV:", err);
                }
            }
        };

        const onTabChange = (event) => {
            state.tabViewActiveIndex = event.index;
            globalSearch.value = "";
            cancelEditDecorrenza();

            switch (event.index) {
                case 0:
                    caricaRichiesteTutelaPod();
                    break;
                case 1:
                    caricaTutelaLavorazionePod();
                    break;
                case 2:
                    caricaTutelaEvasaPod();
                    break;
                case 3:
                    caricaTutelaKOPod();
                    break;
            }
        };

        const onTabChangePdr = (event) => {
            state.tabViewActiveIndexPdr = event.index;
            globalSearchPdr.value = "";
            cancelEditDecorrenza();

            switch (event.index) {
                case 0:
                    caricaRichiesteTutelaPdr();
                    break;
                case 1:
                    caricaTutelaLavorazionePdr();
                    break;
                case 2:
                    caricaTutelaEvasaPdr();
                    break;
                case 3:
                    caricaTutelaKOPdr();
                    break;
            }
        };

        const cambiaStatoConferma = () => {
            let podIds = [];
            let pdrIds = [];

            state.changeTypeStateItems.forEach((ele) => {
                if (ele.code.toUpperCase().startsWith("IT")) {
                    podIds.push(ele.id);
                } else {
                    pdrIds.push(ele.id);
                }
            });

            if (!state.prossimoStato || !state.prossimoStato.id) {
                console.warn("Seleziona uno stato prima di confermare.");
                alert("Seleziona almeno una fornitura e uno stato prima di confermare.");
                return;
            }

            service.cambiaStatoTutelaPodPdr(podIds, pdrIds, state.prossimoStato.id)
                .then(() => {
                    state.showCambiaStatoDialog = false;
                    state.changeTypeStateItems = [];
                })
                .catch((error) => {
                    console.error("Errore durante il cambio stato:", error);
                });

            aggiornaTab();
        };

        const aggiornaTab = () => {
            switch (state.activeAccordionIndex) {
                case 0:
                    switch (state.tabViewActiveIndex) {
                        case 0:
                            caricaRichiesteTutelaPod();
                            break;
                        case 1:
                            caricaTutelaLavorazionePod();
                            break;
                        case 2:
                            caricaTutelaEvasaPod();
                            break;
                        case 3:
                            caricaTutelaKOPod();
                            break;
                    }
                    break;

                case 1:
                    switch (state.tabViewActiveIndexPdr) {
                        case 0:
                            caricaRichiesteTutelaPdr();
                            break;
                        case 1:
                            caricaTutelaLavorazionePdr();
                            break;
                        case 2:
                            caricaTutelaEvasaPdr();
                            break;
                        case 3:
                            caricaTutelaKOPdr();
                            break;
                    }
                    break;
            }
        };

        const eliminaPodPdrDaElenco = (code) => {
            const index = state.changeTypeStateItems.findIndex((ele) => ele.code == code);
            state.changeTypeStateItems.splice(index, 1);
        };

        const onSort = (event) => {
            state.sortField = event.sortField;
            state.sortOrder = event.sortOrder;
            state.currentPage = 1;
            cancelEditDecorrenza();

            if (state.activeAccordionIndex === 0) {
                switch (state.tabViewActiveIndex) {
                    case 0:
                        caricaRichiesteTutelaPod(1, state.rows);
                        break;
                    case 1:
                        caricaTutelaLavorazionePod(1, state.rows);
                        break;
                    case 2:
                        caricaTutelaEvasaPod(1, state.rows);
                        break;
                    case 3:
                        caricaTutelaKOPod(1, state.rows);
                        break;
                }
            } else if (state.activeAccordionIndex === 1) {
                switch (state.tabViewActiveIndexPdr) {
                    case 0:
                        caricaRichiesteTutelaPdr(1, state.rows);
                        break;
                    case 1:
                        caricaTutelaLavorazionePdr(1, state.rows);
                        break;
                    case 2:
                        caricaTutelaEvasaPdr(1, state.rows);
                        break;
                    case 3:
                        caricaTutelaKOPdr(1, state.rows);
                        break;
                }
            }
        };

        const onRowsPerPageChange = (event) => {
            state.rows = event.value;
            state.currentPage = 1;
            cancelEditDecorrenza();

            if (state.activeAccordionIndex === 0) {
                switch (state.tabViewActiveIndex) {
                    case 0:
                        caricaRichiesteTutelaPod(1, state.rows);
                        break;
                    case 1:
                        caricaTutelaLavorazionePod(1, state.rows);
                        break;
                    case 2:
                        caricaTutelaEvasaPod(1, state.rows);
                        break;
                    case 3:
                        caricaTutelaKOPod(1, state.rows);
                        break;
                }
            } else if (state.activeAccordionIndex === 1) {
                switch (state.tabViewActiveIndexPdr) {
                    case 0:
                        caricaRichiesteTutelaPdr(1, state.rows);
                        break;
                    case 1:
                        caricaTutelaLavorazionePdr(1, state.rows);
                        break;
                    case 2:
                        caricaTutelaEvasaPdr(1, state.rows);
                        break;
                    case 3:
                        caricaTutelaKOPdr(1, state.rows);
                        break;
                }
            }
        };

        const onPageChange = (event) => {
            const nextPage = Math.floor(event.first / event.rows) + 1;
            state.rows = event.rows;
            state.currentPage = nextPage;
            cancelEditDecorrenza();

            switch (state.tabViewActiveIndex) {
                case 0:
                    caricaRichiesteTutelaPod(nextPage, event.rows);
                    break;
                case 1:
                    caricaTutelaLavorazionePod(nextPage, event.rows);
                    break;
                case 2:
                    caricaTutelaEvasaPod(nextPage, event.rows);
                    break;
                case 3:
                    caricaTutelaKOPod(nextPage, event.rows);
                    break;
            }
        };

        const onPageChangePdr = (event) => {
            const nextPage = Math.floor(event.first / event.rows) + 1;
            state.rows = event.rows;
            state.currentPage = nextPage;
            cancelEditDecorrenza();

            switch (state.tabViewActiveIndexPdr) {
                case 0:
                    caricaRichiesteTutelaPdr(nextPage, event.rows);
                    break;
                case 1:
                    caricaTutelaLavorazionePdr(nextPage, event.rows);
                    break;
                case 2:
                    caricaTutelaEvasaPdr(nextPage, event.rows);
                    break;
                case 3:
                    caricaTutelaKOPdr(nextPage, event.rows);
                    break;
            }
        };

        const onAccordionChange = (index) => {
            state.activeAccordionIndex = index;
            cancelEditDecorrenza();

            if (index === 0) {
                state.tabViewActiveIndex = 0;
                caricaRichiesteTutelaPod(1, state.rows);
            } else if (index === 1) {
                state.tabViewActiveIndexPdr = 0;
                caricaRichiesteTutelaPdr(1, state.rows);
            }
        };

        const dataPraticaColor = (data) => {
            const dataStr = data.data_pratica;

            if (!dataStr) return "";

            const pratica = new Date(dataStr);
            const oggi = new Date();

            pratica.setHours(0, 0, 0, 0);
            oggi.setHours(0, 0, 0, 0);

            const diffTime = oggi - pratica;
            const diffGiorni = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            if (diffGiorni <= 7) {
                return "";
            } else if (diffGiorni <= 14) {
                return "row-light-yellow";
            } else if (diffGiorni <= 30) {
                return "row-light-orange";
            } else if (diffGiorni <= 60) {
                return "row-light-brown";
            } else {
                return "row-danger";
            }
        };

        onMounted(() => {
            caricaStatiFornitura();
        });

        return {
            pageName: "Rilascio Tutela",
            state,
            globalSearch,
            globalSearchPdr,
            generaCsvPod,
            generaCsvPdr,
            caricaRichiesteTutelaPod,
            caricaTutelaLavorazionePod,
            caricaTutelaEvasaPod,
            caricaTutelaKOPod,
            onAccordionChange,
            onTabChange,
            onTabChangePdr,
            elaborateResponse,
            cambiaStato,
            onSelectionChange,
            eliminaPodPdrDaElenco,
            cambiaStatoConferma,
            onPageChange,
            onPageChangePdr,
            onSearchEnter,
            onSearchEnterPdr,
            onSort,
            onRowsPerPageChange,
            dataPraticaColor,
            formatDateDisplay,
            isEditingDecorrenza,
            startEditDecorrenza,
            cancelEditDecorrenza,
            saveDecorrenza,
            resetDecorrenza
        };
    }
};
</script>

<style scoped>
.custom-tabview .p-tabview-nav {
    display: flex;
    width: 100%;
}

.custom-tabview .p-tabview-nav li {
    flex: 1;
    text-align: center;
}

.custom-tabview .p-tabview-nav li a {
    width: 100%;
    display: block;
}

.custom-sub-title {
    width: 100%;
    text-align: center;
}

#data_table-div {
    padding: 2%;
}

#page-title {
    width: 100%;
    text-align: center;
}

.decorrenza-cell {
    cursor: pointer;
}

.decorrenza-badge--clickable {
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.decorrenza-cell:hover .decorrenza-badge--clickable {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.decorrenza-legend {
    width: 14px;
    height: 14px;
    border-radius: 999px;
    display: inline-block;
    border: 1px solid transparent;
}

.decorrenza-legend--auto {
    background: #e0f2fe;
    border-color: #7dd3fc;
}

.decorrenza-legend--manual {
    background: #fef3c7;
    border-color: #fbbf24;
}

.decorrenza-badge {
    display: inline-flex;
    align-items: center;
    min-height: 2rem;
    padding: 0.35rem 0.75rem;
    border-radius: 999px;
    font-size: 0.9rem;
    font-weight: 600;
    border: 1px solid transparent;
}

.decorrenza-badge--auto {
    background: #e0f2fe;
    color: #075985;
    border-color: #7dd3fc;
}

.decorrenza-badge--manual {
    background: #fef3c7;
    color: #92400e;
    border-color: #fbbf24;
}

.decorrenza-label {
    font-size: 0.75rem;
    font-weight: 600;
}

.decorrenza-label--auto {
    color: #0369a1;
}

.decorrenza-label--manual {
    color: #b45309;
}
</style>